import React from "react";

function DataStatsBlock() {
  return (
    <section className="relative">
      {/* <!--! Font Awesome Pro 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --> */}
      {/* Section background (needs .relative class on parent and next sibling elements) */}
      <div
        className="absolute inset-0 bg-gradient-to-r from-rhoBlueDark-700 to-rhoBlueDark-600 pointer-events-none mb-16"
        aria-hidden="true"
      ></div>
      {/* End section background */}

      {/* 3 Boxes */}
      <div className="relative max-w-6xl mx-auto px-4 sm:px-6">
        <div className="py-4 md:py-4">
          <div className="max-w-3xl mx-auto text-center pb-12 md:pb-16 relative">
            <div className="absolute -left-2 -top-32 text-[220px] text-rhoBlueDark-400/50 z-0 font-georgia">
              <i className="fa-solid fa-quote-left"></i>
            </div>
            <h2 className="h2 text-rhoOffWhite-100 mb-4 mt-8 relative z-10">
              "What impact will this technology have as it scales?"
            </h2>
            <p className="text-2xl text-gray-200 leading-loose">
              We obsess over this question. Seriously.
            </p>
          </div>
          {/* Items */}
          <div className="relative max-w-sm mx-auto grid gap-6 md:grid-cols-1 lg:grid-cols-3 items-start md:max-w-2xl lg:max-w-none">
            {/* 1st item */}
            <a
              href="https://docs.koi.eco/docs/getting-started/quickstart?utm_source=rhoimpact.com"
              className="block"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="group relative grid grid-cols-6 bg-rhoLime-700 text-rhoBlueDark-700 shadow-xl hover:shadow-lg transition-shadow duration-300">
                <div className="col-span-1 p-4 border-t border-r border-l border-rhoBlueDark-700">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                    style={{
                      maxWidth: "40px",
                      maxHeight: "40px",
                      padding: "0 0 5px 0",
                    }}
                  >
                    <path
                      fill="#061530"
                      d="M459.3 267.3c6.2-6.2 6.2-16.4 0-22.6l-160-160c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L425.4 256 276.7 404.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l160-160zm-352 160l160-160c6.2-6.2 6.2-16.4 0-22.6l-160-160c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L233.4 256 84.7 404.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0z"
                    />
                  </svg>
                </div>
                <div className="col-span-5 p-4 border-t border-r border-rhoBlueDark-700">
                  <h4 className="text-xl font-light leading-snug tracking-tight text-center">
                    Interpretable Models
                  </h4>
                </div>
                <div className="text-rhoBlueDark-700 text-center items-center col-span-6 p-8 border border-b-4 border-rhoBlueDark-700">
                  <h2 className="h2 text-7xl font-bold transform transition-transform duration-300 group-hover:translate-x-2 group-hover:-translate-y-2">
                    Thousands
                  </h2>
                </div>
              </div>
            </a>

            {/* 2nd item */}
            <a
              href="https://docs.koi.eco/docs/key-concepts/koi-engine?utm_source=rhoimpact.com"
              className="block"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="group relative grid grid-cols-6 bg-rhoLime-700 text-rhoBlueDark-700 shadow-xl hover:shadow-lg transition-shadow duration-300">
                <div className="col-span-1 p-4 border-t border-r border-l border-rhoBlueDark-700">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                    style={{
                      maxWidth: "40px",
                      maxHeight: "40px",
                      padding: "0 0 5px 0",
                    }}
                  >
                    <path
                      fill="#061530"
                      d="M459.3 267.3c6.2-6.2 6.2-16.4 0-22.6l-160-160c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L425.4 256 276.7 404.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l160-160zm-352 160l160-160c6.2-6.2 6.2-16.4 0-22.6l-160-160c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L233.4 256 84.7 404.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0z"
                    />
                  </svg>
                </div>
                <div className="col-span-5 p-4 border-t border-r border-rhoBlueDark-700">
                  <h4 className="text-xl font-light leading-snug tracking-tight text-center">
                    Faster Modeling
                  </h4>
                </div>
                <div className="text-rhoBlueDark-700 text-center items-center col-span-6 p-8 border border-b-4 border-rhoBlueDark-700">
                  <h2 className="h2 text-7xl font-bold transform transition-transform duration-300 group-hover:translate-x-2 group-hover:-translate-y-2">
                    300x
                  </h2>
                </div>
              </div>
            </a>

            {/* 3rd item */}
            <a
              href="https://koi.eco/about?utm_source=rhoimpact.com"
              className="block"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="group relative grid grid-cols-6 bg-rhoLime-700 text-rhoBlueDark-700 shadow-xl hover:shadow-lg transition-shadow duration-300">
                <div className="col-span-1 p-4 border-t border-r border-l border-rhoBlueDark-700">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                    style={{
                      maxWidth: "40px",
                      maxHeight: "40px",
                      padding: "0 0 5px 0",
                    }}
                  >
                    <path
                      fill="#061530"
                      d="M459.3 267.3c6.2-6.2 6.2-16.4 0-22.6l-160-160c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L425.4 256 276.7 404.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l160-160zm-352 160l160-160c6.2-6.2 6.2-16.4 0-22.6l-160-160c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L233.4 256 84.7 404.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0z"
                    />
                  </svg>
                </div>
                <div className="col-span-5 p-4 border-t border-r border-rhoBlueDark-700">
                  <h4 className="text-xl font-light leading-snug tracking-tight text-center">
                    Research Hours
                  </h4>
                </div>
                <div className="text-rhoBlueDark-700 text-center items-center col-span-6 p-8 border border-b-4 border-rhoBlueDark-700">
                  <h2 className="h2 text-7xl font-bold transform transition-transform duration-300 group-hover:translate-x-2 group-hover:-translate-y-2">
                    50,000+
                  </h2>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default DataStatsBlock;
